import { render, staticRenderFns } from "./AccountPermissionSelector.vue?vue&type=template&id=43288b53&scoped=true"
import script from "./AccountPermissionSelector.vue?vue&type=script&lang=js"
export * from "./AccountPermissionSelector.vue?vue&type=script&lang=js"
import style0 from "./AccountPermissionSelector.vue?vue&type=style&index=0&id=43288b53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43288b53",
  null
  
)

export default component.exports